var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 256 256",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Surfaces"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo_Surface",
    "data-name": "Photo Surface"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_no_shadow",
    "data-name": "Outline no shadow"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#300",
    height: 232,
    rx: 42,
    width: 240,
    x: 8,
    y: 12
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff9a00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.79 156h-35.79l-9.24 26.68q-.16 1.32-1.67 1.32h-16.8q-1.68 0-1.17-1.65l32.42-96.29a29.5 29.5 0 0 0 1.34-9.06.89.89 0 0 1 1-1h23.52c.68 0 1.07.28 1.18.82l36.28 105.7c.34 1 .06 1.48-.84 1.48h-18.81a1.74 1.74 0 0 1 -1.68-1zm-31.79-18h27.88c-.67-1.47-13.21-41.93-14.11-45.34h-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.91 96a11.81 11.81 0 0 1 -8.61-3.21 11.55 11.55 0 0 1 -3.3-8.7 11.71 11.71 0 0 1 3.39-8.79 12 12 0 0 1 8.7-3.3 11.55 11.55 0 0 1 8.7 3.3 12.07 12.07 0 0 1 3.21 8.79 11.55 11.55 0 0 1 -3.3 8.7 12.07 12.07 0 0 1 -8.79 3.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170 182.5v-77.16a1.18 1.18 0 0 1 1.34-1.34h17.32a1.19 1.19 0 0 1 1.34 1.34v77.32a1.18 1.18 0 0 1 -1.34 1.34h-17.16a1.33 1.33 0 0 1 -1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.eab27269047e3c5a8d96888ca1b8b74d.svg";
export { ForwardRef as ReactComponent };